"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.76,0H2.24a.56.56,0,0,0-.63.64V20.15a.56.56,0,0,0,.63.64H8.63l3.21,3.15a.24.24,0,0,0,.32,0l3.21-3.15h6.39a.56.56,0,0,0,.63-.64V.64A.56.56,0,0,0,21.76,0Z",
    style: {
      fill: '#004864'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.74,6.4c.35,1.44,2.17.73,2.33-.12.23-1.27-1-1.8-3-1.75C9.47,4.62,4.86,7.31,4.34,12a3.94,3.94,0,0,0,4,4.18,6.65,6.65,0,0,0,2.86-.48c.55-.21,1.91-.87,1.91-1.54a.3.3,0,0,0-.29-.28c-.3,0-.79.58-1,.69a5,5,0,0,1-3.22.65c-2-.41-2.43-2.71-1.52-5C7.73,8.53,9.52,5,13.78,5.4c.47,0-.13.64,0,1",
    style: {
      fill: '#fff',
      fillRule: 'evenodd'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.14,11c.13,0,.14.14.13.27,0,.47.19.4.53.44.5,0,.84-.36.88-1s-.23-1-.64-1c-1.13,0-1.91,1.86-2.51,3l.16-.63a9.65,9.65,0,0,0,.32-1.6c0-.5-.16-.73-.52-.73a2.44,2.44,0,0,0-1.62,1.08,2.77,2.77,0,0,0-.59.94c0,.1.05.17.11.17.23,0,.78-1.1,1.14-1.1.1,0,.12.12.11.22a8.39,8.39,0,0,1-.31,1.22l-1,3-.1.32c0,.07-.07.28-.08.33,0,.21.24.17.34.17h.28c.17,0,.59,0,.74-.11a1.56,1.56,0,0,0,.21-.43c.64-2.32,2-4.59,2.4-4.59",
    style: {
      fill: '#fff',
      fillRule: 'evenodd'
    }
  }));
};

exports["default"] = _default;